import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appInputNumbersOnly]',
  standalone: false,
})
export class InputNumbersOnlyDirective {
  private specialKeys: Array<string> = ['Backspace', 'Delete', 'Tab'];

  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent) {
    const key = e.key;
    if (this.specialKeys.indexOf(key) !== -1) {
      return;
    }
    if (key === ' ' || isNaN(Number(key))) {
      e.preventDefault();
    }
  }
}
